import { ICol, IRow } from "./../types";

export function getWidth(columns: ICol[], colspan: number, index: number) {
	const cols = columns.filter(({ hidden }) => !hidden);
	if (!colspan) {
		return cols[index].$width;
	}
	return cols.reduce((width, { $width }, i) => {
		width += i >= index && i < index + colspan ? $width : 0;
		return width;
	}, 0);
}

export function getHeight(dataRows: IRow[], rowspan: number, index: number) {
	const rows = dataRows.filter(({ hidden }) => !hidden);
	if (!rowspan) {
		return rows[index].$height;
	}
	return rows.reduce((height, { $height }, i) => {
		height += i >= index && i < index + rowspan ? $height : 0;
		return height;
	}, 0);
}
